export default __webpack_public_path__ + "static/media/uoftlogo.c6591ecf.png";